module.exports = __webpack_public_path__ + "fa57119abac27aba0dae744ce25b3b73.woff2";